import { render, staticRenderFns } from "./DocumentPageLoader.vue?vue&type=template&id=cb2ab8bc&scoped=true"
import script from "./DocumentPageLoader.vue?vue&type=script&lang=js"
export * from "./DocumentPageLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2ab8bc",
  null
  
)

export default component.exports